import { createSelector } from 'reselect'
import { State } from 'index'

const basketSelector = (state: State) => state.basket

export const getBaskets = createSelector([basketSelector], (state) => state.baskets)
